import { AccountType } from "@qid/core";
import { AccountAttributeType } from "../enums/account-attribute-type.enum";

export class AccountAttribute {

  _id?: string;

  account_id?: string;

  accountType?: AccountType;

  attributeType?: AccountAttributeType;

  value?: any;

  verificationMethod?: string;

  document_id?: string;
}
